import { useState } from "react";

const ACOES = [
  { chave: "leitura", label: "Ler" },
  { chave: "gravacao", label: "Criar" },
  { chave: "edicao", label: "Editar" },
  { chave: "exclusao", label: "Excluir" },
];

/**
 * Grid reutilizável Módulo -> Tela -> 4 ações (leitura/gravação/edição/exclusão).
 * `modulos`: lista de { id, nome, telas: [{ id, nome, chave }] } (de /configuracoes/modulos/).
 * `valores`: mapa { [telaId]: { leitura, gravacao, edicao, exclusao } }.
 * `onChange(telaId, acao, valor)`: chamado a cada toggle.
 */
export default function TelaPermissoesGrid({ modulos, valores, onChange, somenteLeitura = false }) {
  const [modulosAbertos, setModulosAbertos] = useState(new Set());

  const toggleModuloAberto = (moduloId) => {
    setModulosAbertos((prev) => {
      const novo = new Set(prev);
      novo.has(moduloId) ? novo.delete(moduloId) : novo.add(moduloId);
      return novo;
    });
  };

  const valorDe = (telaId, acao) => valores[telaId]?.[acao] ?? false;

  const estadoModulo = (modulo) => {
    const total = modulo.telas.length * ACOES.length;
    let marcadas = 0;
    modulo.telas.forEach((tela) => ACOES.forEach((a) => { if (valorDe(tela.id, a.chave)) marcadas += 1; }));
    if (marcadas === 0) return "vazio";
    if (marcadas === total) return "completo";
    return "parcial";
  };

  const toggleModuloTodo = (modulo) => {
    const completo = estadoModulo(modulo) === "completo";
    modulo.telas.forEach((tela) => ACOES.forEach((a) => onChange(tela.id, a.chave, !completo)));
  };

  const toggleTelaTodo = (tela) => {
    const completo = ACOES.every((a) => valorDe(tela.id, a.chave));
    ACOES.forEach((a) => onChange(tela.id, a.chave, !completo));
  };

  return (
    <div className="space-y-2">
      {modulos.map((modulo) => {
        const estado = estadoModulo(modulo);
        const aberto = modulosAbertos.has(modulo.id);
        return (
          <div key={modulo.id} className="border rounded-lg overflow-hidden">
            <div className="flex items-center gap-3 p-3 bg-gray-50">
              <input
                type="checkbox"
                checked={estado === "completo"}
                ref={(el) => { if (el) el.indeterminate = estado === "parcial"; }}
                onChange={() => toggleModuloTodo(modulo)}
                disabled={somenteLeitura}
                className="accent-[#1a3d2a] w-4 h-4"
              />
              <button
                type="button"
                onClick={() => toggleModuloAberto(modulo.id)}
                className="flex-1 flex items-center justify-between text-left"
              >
                <span className="text-sm font-medium text-gray-800">{modulo.nome}</span>
                <span className="text-gray-400 text-xs">{aberto ? "▲" : "▼"}</span>
              </button>
            </div>
            {aberto && (
              <div className="divide-y">
                {modulo.telas.map((tela) => (
                  <div key={tela.id} className="flex items-center gap-3 p-2 pl-6 text-sm">
                    <input
                      type="checkbox"
                      checked={ACOES.every((a) => valorDe(tela.id, a.chave))}
                      onChange={() => toggleTelaTodo(tela)}
                      disabled={somenteLeitura}
                      className="accent-[#1a3d2a] w-3.5 h-3.5"
                    />
                    <span className="flex-1 text-gray-700">{tela.nome}</span>
                    <div className="flex gap-3">
                      {ACOES.map((a) => (
                        <label key={a.chave} className="flex items-center gap-1 text-xs text-gray-500 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={valorDe(tela.id, a.chave)}
                            onChange={(e) => onChange(tela.id, a.chave, e.target.checked)}
                            disabled={somenteLeitura}
                            className="accent-[#1e40af]"
                          />
                          {a.label}
                        </label>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
